<template>
  <v-row align="center" justify="center">
    <v-col cols="12" md="6">
      <div class="hero-badge">
        <v-icon small class="mr-1" color="error">mdi-chart-box</v-icon>
        Relatórios completos
      </div>

      <SectionTitle class="mt-3">Acompanhe os números de onde estiver</SectionTitle>

      <p class="section-desc mt-4">
        Acesse os relatórios no computador ou no celular e acompanhe cada detalhe da sua operação para tomada de decisão estratégica.
      </p>

      <div class="feature-list mt-6">
        <div v-for="(item, i) in features" :key="i" class="feature-item">
          <div class="feature-icon-wrap">
            <v-icon size="20" color="error">{{ item.icon }}</v-icon>
          </div>
          <span>{{ item.text }}</span>
        </div>
      </div>

      <div class="mt-7">
        <CtaButton>Quero no meu negócio</CtaButton>
      </div>
    </v-col>

    <v-col cols="12" md="6" class="d-flex justify-center">
      <img
        :src="require('@/assets/images/tablet-relatorios.webp')"
        class="reports-img"
        alt="Painel de relatórios do ZaperMenu no computador e no celular, com faturamento, custos, lucro e produtos mais vendidos"
        width="1200"
        height="810"
        loading="lazy"
        decoding="async"
      />
    </v-col>
  </v-row>
</template>

<script>
  import SectionTitle from '@/components/SectionTitle.vue';
  import CtaButton from '@/components/CtaButton.vue';

  export default {
    name: 'TabletReportsSection',

    components: {
      SectionTitle,
      CtaButton,
    },

    data: () => ({
      features: [
        { icon: 'mdi-cash-multiple', text: 'Vendas, custos e lucro do período' },
        { icon: 'mdi-chart-bar', text: 'Faturamento diario, mensal e anual' },
        { icon: 'mdi-podium-gold', text: 'Ranking de produtos mais vendidos' },
        { icon: 'mdi-cart-arrow-up', text: 'Ticket médio e muito mais' },
      ],
    }),
  };
</script>

<style scoped lang="scss">
  .reports-img {
    display: block;
    width: 100%;
    max-width: 590px;
    height: auto;
  }

  .hero-badge {
    display: inline-flex;
    align-items: center;
    padding: 5px 14px;
    border-radius: 999px;
    border: 1px solid rgba(244, 6, 18, 0.35);
    background: rgba(244, 6, 18, 0.08);
    font-size: 13px;
    font-weight: 600;
    color: #f40612;
    letter-spacing: 0.02em;
  }

  .section-desc {
    font-size: 16px;
    line-height: 1.7;
    color: var(--text-secondary);
    margin: 0;
    max-width: 480px;
  }

  .feature-list {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .feature-item {
    display: flex;
    align-items: center;
    gap: 14px;
    font-size: 15px;
    color: var(--text-secondary);
  }

  .feature-icon-wrap {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 12px;
    background: rgba(244, 6, 18, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
